<template>
  <div
    class="chart-box"
    :style="
      chartConfig && chartConfig.chartBoxStyle ? chartConfig.chartBoxStyle : {}
    "
  >
    <Loading v-if="loading" />
    <component
      :is="chartConfig.chartType"
      :item="chartConfig"
      :index="index"
      :intervalTime="intervalTime"
      :data="chartSource"
      :childSource="childSource"
      :type="type"
      :childQuery="headerValue"
      :show-more-options="showMoreOptions"
      :moreOptionsData="moreOptionsData"
      @handle-more-options-click="
        () => $emit('handle-more-options-click', graphConfig.title)
      "
      :compareChildQuery="compareHeaderValue"
      :isMultiLineSeriesTooltip="chartConfig.isMultiLineSeriesTooltip"
      :compareIntervalTime="compareIntervalTime"
      v-else
    ></component>
    <!-- :childQuery="headerValue" -->
  </div>
</template>
<script>
import charts from '@/components/charts/index';
import { mapActions, mapGetters, mapState } from 'vuex';
import { QueryTypes } from '@/components/Common/constant';
import { CalculationType } from '@/components/charts/constant';
import dayjs from 'dayjs';
import Loading from '@/rex-components/rex-loading.vue';
import {
  CAPABILITY_APM,
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
  CAPABILITY_SM,
  CAPABILITY_VM,
  CAPABILITY_K8M,
} from '@/utils/constants';
import { GetConstantValues } from '@/utils/metrics-constants/mapper';
import { COMPARED } from '@/components/Common/constant.ts';
export default {
  name: 'GraphBuilder',
  components: { ...charts, Loading },
  emits: ['handle-more-options-click'],
  data: function () {
    return {
      type: undefined,
      itemConfig: {},
      chartSource: {},
      childSource: [],
      headerValue: {},
      dialogConfigVisible: false,
      dependency: undefined,
      height: '200',
      pageTypes: ['TOPOLOGY_ENDPOINT', 'TOPOLOGY_INSTANCE'],
      loading: true,
      compareHeaderValue: {},
    };
  },
  props: {
    chartConfig: {},
    index: {},
    home: {},
    layoutIndex: {},
    serviceId: String,
    moreOptionsData: { type: Array, default: () => [] },
    showMoreOptions: { type: Boolean, default: false },
  },
  computed: {
    ...mapState('globalState/app', [
      'updateDashboard',
      'currentCapability',
      'compareSupportedCapabilities',
      'currentSideNav',
    ]),

    ...mapState('apmState/dashboard', ['apdexEnabled']),
    ...mapState('cloudState/detail', ['currentServices']),
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
    ...mapState('apmState/dashboard', ['isCompareOptionsSelected']),
    ...mapState('globalState/settings', ['isCompareOptionsSelected']),
    ...mapGetters('globalState/settings', [
      'getDurationTime',
      'intervalTime',
      'compareIntervalTime',
      'getIsCompareOptionsSelected',
      'getCompareDurationTime',
      'comapareDuration',
    ]),
    getHeight() {
      if (this.chartConfig.chartType === 'ChartNum') {
        return '3.75rem';
      } else return '8.4375rem';
    },
    ...mapState('browserState/browserCommonState', [
      'syntheticUserEnabled',
      'browserApdexEnabled',
    ]),
    isCompareSelected() {
      return (
        this.getIsCompareOptionsSelected &&
        this.compareSupportedCapabilities.includes(this.currentSideNav.key)
      );
    },
  },

  methods: {
    ...mapActions('globalState/app', { getGraphDataAction: 'getGraphData' }),
    async chartRender() {
      const options = {
        duration: this.getDurationTime,
        index: this.index,
        type: this.type,
        layoutIndex: this.layoutIndex,
        children: { present: false, childIndex: 0 },
        dashboardType: {
          type: this.chartConfig.entityType,
          isDatabase: this.chartConfig.isDatabase,
        },
        dependency: this.chartConfig.dependency,
        serviceId: this.serviceId,
        isTraceGraph: this.chartConfig.isTraceGraph,
        config: this.chartConfig,
      };
      if (this.isCompareOptionsSelected) {
        options.compareDuration = this.getCompareDurationTime;
      }
      await this.getGraphDataAction(options)
        //params are of type : Array<{ metricName: string; [key: string]: any; config: any }>
        .then(async (params) => {
          if (!params) {
            this.chartSource = {};
            return;
          }
          if (!params.length) {
            this.chartSource = {};
            return;
          }
          this.itemConfig = params[0].config;
          const { queryMetricType, chartType } = this.itemConfig;
          let data = params;
          if (
            queryMetricType ===
            QueryTypes.ReadMetricsValue /*&& chartType === 'ChartSlow'*/
          ) {
            const arr = [
              {
                config: this.itemConfig,
                [QueryTypes.ReadMetricsValue]: params.map((item, index) => {
                  return {
                    id: index,
                    name: item.metricName,
                    value: item[QueryTypes.ReadMetricsValue],
                  };
                }),
              },
            ];
            data = arr;
          } else if (
            queryMetricType !== QueryTypes.ReadMetricsValues ||
            queryMetricType === QueryTypes.ReadCustomMetricsValues ||
            queryMetricType === QueryTypes.GetGraphDataValuesPulse
          ) {
            /**
             * **Special Case for browser** .
             * Change: New if condition introduced.
             * Info :It was introduced in Synthetic Monitoring .
             * Contact : @Tarun Rawat for this
             * for : For Multiple data point graphs
             * More details :
             * Metric type was changed to "readCustomMetricsValues" from "readMetricValues"
             * multiple data graphs like User centric page load and event execution time and  Error by resource graph on Pages tab are handled here
             * Since these graphs have multiple values,hence params array will have length more than 1
             */
            if (
              (this.currentCapability === CAPABILITY_BROWSER ||
                this.currentCapability === CAPABILITY_MOBILE ||
                this.currentCapability === CAPABILITY_SM) &&
              params.length > 1
            ) {
              data = params;
            } else data = [params[0]];
          }
          await this.chartValue(data);
          if (this.itemConfig.childQueries) {
            this.childSource = [];
            this.getChildQueries(this.chartConfig.childQueries, this.index);
          }
        })
        .catch((error, a) => {
          console.log('GET_QUERY failed ' + error.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getChildQueries(childQueries, parentIndex) {
      if (!childQueries) {
        return;
      }
      childQueries.forEach((item, childIndex) => {
        this.getGraphDataAction({
          duration: this.getDurationTime,
          index: parentIndex,
          type: this.type,
          layoutIndex: this.layoutIndex,
          children: { present: true, childIndex: childIndex },
          dashboardType: {
            type: item.entityType,
            isDatabase: this.chartConfig.isDatabase,
          },
          ...(this.isCompareOptionsSelected && {
            compareDuration: this.getCompareDurationTime,
          }),
        })
          //params are of type : Array<{ metricName: string; [key: string]: any; config: any }>
          .then((params) => {
            if (!params) {
              return;
            }

            if (!params.length) {
              return;
            }
            this.itemConfig = params[0].config;
            const { queryMetricType, chartType } = this.itemConfig;
            let data = params;
            if (
              queryMetricType ===
              QueryTypes.ReadMetricsValue /*&& chartType === 'ChartSlow'*/
            ) {
              const arr = [
                {
                  config: this.itemConfig,
                  [QueryTypes.ReadMetricsValue]: params.map((item, index) => {
                    return {
                      id: index,
                      name: item.metricName,
                      value: item[QueryTypes.ReadMetricsValue],
                    };
                  }),
                  [QueryTypes.ReadMetricsValue + '_compared']: params.map(
                    (item, index) => {
                      return {
                        id: index,
                        name: item.metricName + '_compared',
                        value: item['compared'],
                      };
                    },
                  ),
                },
              ];
              data = arr;
            } else if (queryMetricType !== QueryTypes.ReadMetricsValues) {
              data = [params[0]];
            }
            this.childQueryValue(data, item.name);
            // this.loading = false;
          })
          .catch((error) => {
            console.log('GET_QUERY failed ' + error.message);
          });
      });
    },
    // params type : Array<{ metricName: string; [key: string]: any; config: any }>
    chartValue(data) {
      this.chartSource = {};
      for (const params of data) {
        const {
          queryMetricType,
          aggregation,
          aggregationNum,
          metricLabels,
          labelsIndex,
          chartType,
          metricName,
        } = params.config;
        let resVal = params[queryMetricType];
        let compareResVal = params[COMPARED];
        if (
          queryMetricType ===
          QueryTypes.ReadAndAggregateMetricsFilteredAtServiceScope
        ) {
          resVal = resVal[0];
        }
        if (queryMetricType === QueryTypes.ReadMetricsValue) {
          if (
            chartType === 'ChartGauge' &&
            ((this.currentCapability === CAPABILITY_BROWSER &&
              !this.browserApdexEnabled) ||
              (this.currentCapability === CAPABILITY_APM && !this.apdexEnabled))
          ) {
            this.handleChartGaugeData(resVal);
          } else if (chartType === 'ChartSlow') {
            this.handleChartSlowData(
              resVal,
              aggregation,
              aggregationNum,
              metricName,
            );
          } else {
            this.chartSource = (resVal || []).map((item) => {
              return {
                name: item.name,
                avgNum: [
                  CalculationType[4].value,
                  CalculationType[5].value,
                ].includes(aggregation)
                  ? this.formatDate({
                      data: item.value,
                      type: aggregation,
                      aggregationNum,
                    })
                  : this.aggregationValue({
                      data: item.value,
                      type: aggregation,
                      aggregationNum: Number(aggregationNum),
                    }),
              };
            });
          }
        }
        // if (queryMetricType === QueryTypes.ReadMetricsValues) {
        if (
          queryMetricType === QueryTypes.ReadMetricsValues ||
          queryMetricType === QueryTypes.ReadCustomMetricsValues ||
          queryMetricType === QueryTypes.GetGraphDataValuesPulse ||
          queryMetricType ===
            QueryTypes.ReadAndAggregateMetricsFilteredAtServiceScope
        ) {
          if (!(resVal && resVal.values)) {
            this.chartSource[params.metricName] = [];
            return;
          }
          if (resVal.values) {
            this.headerValue = {
              avg: resVal.avg,
              total: resVal.total,
              perMin: resVal.perMin,
            };
          }
          const { values } = resVal.values;
          const comparedValues = compareResVal?.values?.values;
          this.chartSource[params.metricName] = values.map((item) =>
            this.aggregationValue({
              data: item.value,
              type: aggregation,
              aggregationNum: Number(aggregationNum),
            }),
          );
          if (
            this.getIsCompareOptionsSelected &&
            compareResVal?.values &&
            (this.currentCapability === CAPABILITY_BROWSER ||
              this.currentCapability === CAPABILITY_MOBILE ||
              this.currentCapability === CAPABILITY_APM ||
              this.currentCapability === CAPABILITY_VM ||
              this.currentCapability === CAPABILITY_K8M)
          ) {
            this.compareHeaderValue = {
              avg: compareResVal?.avg,
              total: compareResVal?.total,
              perMin: compareResVal?.perMin,
            };
            this.chartSource[params.metricName + '_compared'] =
              comparedValues?.map((item) =>
                this.aggregationValue({
                  data: item.value,
                  type: aggregation,
                  aggregationNum: Number(aggregationNum),
                }),
              );
          }
          let seriesKey = GetConstantValues.prototype.getValueByConstantName(
            params.metricName,
          );
          if (seriesKey) {
            this.chartSource[seriesKey] = this.chartSource[params.metricName];
            delete this.chartSource[params.metricName];
            if (this.getIsCompareOptionsSelected) {
              const comparedSeriesKey = `${seriesKey}_compared`;
              this.chartSource[comparedSeriesKey] =
                this.chartSource[params.metricName + '_compared'];
              delete this.chartSource[params.metricName + '_compared'];
            }
          }
        }
        if (
          queryMetricType === QueryTypes.SortMetrics ||
          queryMetricType === QueryTypes.ReadSampledRecords
        ) {
          this.handleChartSlowData(
            resVal,
            aggregation,
            aggregationNum,
            metricName,
          );
        }
        if (queryMetricType === QueryTypes.READHEATMAP) {
          const nodes = [];
          if (!(resVal && resVal.values)) {
            this.chartSource = { nodes: [] };
            return;
          }
          resVal.values.forEach((items, x) => {
            const grids = items.values.map((val, y) => [
              x,
              y,
              this.aggregationValue({
                data: val,
                type: aggregation,
                aggregationNum: Number(aggregationNum),
              }),
            ]);

            nodes.push(...grids);
          });
          let buckets = [];
          if (resVal.buckets.length) {
            buckets = [
              resVal.buckets[0].min,
              ...resVal.buckets.map((item) => item.max),
            ];
          }

          this.chartSource = { nodes, buckets }; // nodes: number[][]
        }
        if (queryMetricType === QueryTypes.readMetricsTotalValue) {
          // this.chartSource = { nodes, buckets }; // nodes: number[][]
        }
        if (queryMetricType === QueryTypes.ReadMobileCustomMetricsValues) {
          if (resVal.length === 0) {
            this.chartSource[params.metricName] = [];
          }
          if (compareResVal?.values && this.getIsCompareOptionsSelected) {
            this.compareHeaderValue = {
              avg: compareResVal?.avg,
              total: compareResVal?.total,
              perMin: compareResVal?.perMin,
            };
            const comparedValues = compareResVal?.values?.values;
            this.chartSource[params.metricName + '_compared'] =
              comparedValues?.map((item) =>
                this.aggregationValue({
                  data: item,
                  type: aggregation,
                  aggregationNum: Number(aggregationNum),
                }),
              );
          }
          this.chartSource = {};
          if (
            params.config.responseType !== 'dynamic' ||
            params.config.responseType === 'undefined'
          ) {
            const { values } = resVal.values;
            this.chartSource[params.metricName] = values.map((item) =>
              this.aggregationValue({
                data: item,
                type: aggregation,
                aggregationNum: Number(aggregationNum),
              }),
            );
            if (this.getIsCompareOptionsSelected) {
              const comparedValues =
                compareResVal?.values?.values?.map((item) =>
                  this.aggregationValue({
                    data: item,
                    type: aggregation,
                    aggregationNum: Number(aggregationNum),
                  }),
                ) || new Array(values.length).fill(null);

              this.chartSource[params.metricName + '_compared'] =
                comparedValues;
            }
          } else {
            const labels = (metricLabels || '')
              .split(',')
              .map((item) => item.trim());
            const indexList = (labelsIndex || '')
              .split(',')
              .map((item) => item.trim());
            const resMap = new Map();
            const compareMap = new Map();
            const allLabels = new Set();
            for (const item of resVal) {
              const list = item.values.values.map((d) =>
                this.aggregationValue({
                  data: d,
                  type: aggregation,
                  aggregationNum: Number(aggregationNum),
                }),
              );
              const indexNum = indexList.findIndex((d) => d === item.label);
              const finalLabel =
                labels[indexNum] && indexNum > -1
                  ? labels[indexNum]
                  : item.label;

              allLabels.add(finalLabel);
              resMap.set(finalLabel, list);
            }
            if (this.getIsCompareOptionsSelected) {
              for (const compareItem of compareResVal) {
                const cleanLabel = compareItem.label.replace('_compared', '');
                allLabels.add(cleanLabel);

                const list = compareItem.values.values.map((d) =>
                  this.aggregationValue({
                    data: d,
                    type: aggregation,
                    aggregationNum: Number(aggregationNum),
                  }),
                );
                compareMap.set(cleanLabel, list);
              }
            }
            for (const label of allLabels) {
              if (!resMap.has(label)) {
                resMap.set(label, [null, null, null]);
              }
              if (!compareMap.has(label)) {
                compareMap.set(label, [null, null, null]);
              }
            }
            for (const label of allLabels) {
              this.chartSource[label] = resMap.get(label);
              if (this.getIsCompareOptionsSelected) {
                this.chartSource[label + '_compared'] = compareMap.get(label);
              }
            }
          }
        }
        if (queryMetricType === QueryTypes.ReadLabeledMetricsValues) {
          const labels = (metricLabels || '')
            .split(',')
            .map((item) => item.trim());
          const indexList = (labelsIndex || '')
            .split(',')
            .map((item) => item.trim());

          this.chartSource = {};

          const resMap = new Map();
          const allLabels = new Set();

          for (const item of resVal || []) {
            allLabels.add(item.label);
            resMap.set(
              item.label,
              item.values.values.map((d) =>
                this.aggregationValue({
                  data: d.value,
                  type: aggregation,
                  aggregationNum: Number(aggregationNum),
                }),
              ),
            );
          }
          const compareMap = new Map();
          for (const compareItem of compareResVal || []) {
            const cleanLabel = compareItem.label.replace('_compared', '');
            allLabels.add(cleanLabel);
            compareMap.set(
              cleanLabel,
              compareItem.values.values.map((d) =>
                this.aggregationValue({
                  data: d.value,
                  type: aggregation,
                  aggregationNum: Number(aggregationNum),
                }),
              ),
            );
          }
          for (const label of allLabels) {
            if (!resMap.has(label)) {
              resMap.set(label, [null, null, null]);
            }
            if (!compareMap.has(label)) {
              compareMap.set(label, [null, null, null]);
            }
          }

          for (const label of allLabels) {
            const indexNum = indexList.findIndex((d) => d === label);
            const finalLabel =
              labels[indexNum] && indexNum > -1 ? labels[indexNum] : label;

            this.chartSource[finalLabel] = resMap.get(label);

            if (this.isCompareSelected) {
              this.chartSource[finalLabel + '_compared'] =
                compareMap.get(label);
            }
          }
        }
      }
    },
    childQueryValue(data, metricType) {
      for (const params of data) {
        const {
          queryMetricType,
          aggregation,
          aggregationNum,
          chartType,
          metricName,
        } = params.config;
        const resVal = params[queryMetricType];
        const compareResVal = params[queryMetricType + '_' + COMPARED];
        if (queryMetricType === QueryTypes.ReadMetricsValue) {
          if (chartType === 'ChartSlow') {
            // this.handleChartSlowData(
            //   resVal,
            //   aggregation,
            //   aggregationNum,
            //   metricName
            // );
          } else {
            if (this.getIsCompareOptionsSelected) {
              const resArray = (resVal || []).map((item) => {
                return {
                  name: item.name,
                  avgNum: item.value,
                  metricType: metricType,
                };
              });
              const compareResArray = (compareResVal || []).map((item) => {
                return {
                  name: item.name,
                  avgNum: item.value,
                  metricType: metricType,
                };
              });
              this.childSource = [
                ...this.childSource,
                resArray[0] || [],
                compareResArray[0] || [],
              ];
            } else {
              const resArray = (resVal || []).map((item) => {
                return {
                  name: item.name,
                  avgNum: item.value,
                  metricType: metricType,
                };
              });
              this.childSource = [...this.childSource, resArray[0] || []];
            }
          }
        }

        if (queryMetricType === QueryTypes.ReadMetricsTotalValue) {
          const metricsValueTotal = {
            avgNum: resVal,
            name: metricName,
            metricType: metricType,
          };
          this.childSource = [...this.childSource, metricsValueTotal];
        }
      }
      // this.loading = false;
    },
    //type : { data: number; type: string; aggregationNum: string }
    formatDate(json) {
      let { aggregationNum } = json;
      if (!aggregationNum) {
        aggregationNum = 'YYYY-MM-DD HH:mm:ss';
      }
      if (json.type === CalculationType[4].value) {
        return dayjs(json.data).format(aggregationNum);
      } else if (json.type === CalculationType[5].value) {
        return dayjs.unix(json.data).format(aggregationNum);
      } else {
        return json.data;
      }
    },
    //type : { data: number; type: string; aggregationNum: number }
    aggregationValue(json) {
      if (isNaN(json.aggregationNum)) {
        return Math.round(json.data * 100) / 100;
      }
      if (json.type === CalculationType[0].value) {
        return Math.round((json.data + json.aggregationNum) * 100) / 100;
      }
      if (json.type === CalculationType[1].value) {
        return Math.round((json.data - json.aggregationNum) * 100) / 100;
      }
      if (json.type === CalculationType[2].value) {
        return Math.round(json.data * json.aggregationNum * 100) / 100;
      }
      if (json.type === CalculationType[3].value) {
        return Math.round((json.data / json.aggregationNum) * 100) / 100;
      }
      return Math.round(json.data * 100) / 100;
    },

    handleChartSlowData(resVal, aggregation, aggregationNum, metricName) {
      if (metricName === 'endpoint_slow_traces') {
        resVal = this.rocketData.slowTraces;
        this.showgraph = resVal.length ? true : false;
      }
      this.chartSource = (resVal || []).map((item) => {
        return {
          ...item,
          value: this.aggregationValue({
            data: item.value,
            type: aggregation,
            aggregationNum: Number(aggregationNum),
          }),
        };
      });
    },

    handleChartGaugeData(resVal) {
      this.chartSource = (resVal || []).map((item) => {
        return {
          ...item,
          avgNum: 0,
        };
      });
    },
  },
  watch: {
    updateDashboard(oldValue, newValue) {
      setTimeout(() => {
        this.chartRender();
      }, 300);
    },
    getDurationTime(oldValue, newValue) {
      setTimeout(() => {
        this.chartRender();
      }, 300);
    },
    currentServices(newValue, oldVal) {
      setTimeout(() => {
        this.chartRender();
      }, 300);
    },
    syntheticUserEnabled: function (oldVal, newVal) {
      this.chartRender();
    },
    browserApdexEnabled: function (oldVal, newVal) {
      this.chartRender();
    },
    apdexEnabled: function (oldVal, newVal) {
      this.chartRender();
    },
    getIsCompareOptionsSelected() {
      setTimeout(() => {
        this.chartRender();
      }, 300);
    },
  },
  mounted() {
    this.itemConfig = this.chartConfig;
    setTimeout(() => {
      this.chartRender();
    }, 200);
  },
};
</script>
<style lang="scss" scoped>
.chart-box {
  width: 100%;
  height: 23.75em;
  @include dropshadow-effect;
  // border: 0.1px solid rgb(53, 64, 83);
  border-radius: 1.0625em;
  background-color: $bg-secondary;
}
</style>
